














































import demo1 from './demo1.vue';
import demo2 from './demo2.vue';
import demo3 from './demo3.vue';
import demo4 from './demo4.vue';
import Anchor from '@/packages/d-anchor';
import Vue from 'vue';
import Component from 'vue-class-component';
import AeIcon from '@/packages/ae-icon';
import title from '../../packages/ae-icon/demo/README.md';
import props from '../../packages/ae-icon/demo/props.md';

Vue.use(Anchor);
Vue.use(AeIcon);
@Component({
  name: 'ComponentDemo',
  components: {
    demo1, demo2, demo3, demo4
  }
})
export default class ComponentDemo extends Vue {
  public title = title;
  public props = props;

  public getContainer() {
    return document.getElementById('app-content');
  }
}
